module.exports = __webpack_public_path__ + "static/media/gpu.44e567cf.png";